import API from "../api";

export const listBatches = (role, params = {}) => {
  const base =
    role === "ADMIN"
      ? "/admin/batches"
      : role === "MANAGER"
      ? "/manager/batches"
      : "/coach/batches";
  return API.get(base, { params });
};

export const createBatch = (payload) => API.post("/admin/batches", payload);
export const updateBatch = (id, payload) =>
  API.put(`/admin/batches/${id}`, payload);
export const archiveBatch = (id) => API.delete(`/admin/batches/${id}`);

export const createBatchManager = (payload) =>
  API.post("/manager/batches", payload);
export const updateBatchManager = (id, payload) =>
  API.put(`/manager/batches/${id}`, payload);
export const archiveBatchManager = (id) => API.delete(`/manager/batches/${id}`);
